import { styled } from '@mui/material';
import { DataGridPro, DataGridProProps, gridClasses } from '@mui/x-data-grid-pro';

export const Grid = styled(DataGridPro)<
  DataGridProProps & { disableCellSelection?: boolean; disableHorizontalScroll?: boolean }
>({
  [`& .${gridClasses.columnHeaders}`]: {
    background: '#F8F8F8',
    color: '#737373',
    '.MuiDataGrid-columnHeaderTitle': {
      fontWeight: 600,
      fontSize: 14,
      fontFamily: 'Manrope',
    },
  },
  [`& .${gridClasses.cell}`]: {
    fontSize: 14,
    fontWeight: 600,
  },
  [`& .${gridClasses.footerContainer}`]: {
    borderTop: 'none',
  },
  [`& .${gridClasses.main}`]: {
    border: '1px solid rgb(227, 227, 227)',
    boxSizing: 'content-box',
    '@media print': {
      boxSizing: 'border-box',
      width: '100%',
      border: 'none',
    },
  },
  '@media print': {
    [`& .${gridClasses.columnHeader}, & .${gridClasses.cell}`]: {
      paddingLeft: '6px',
      paddingRight: '6px',
    },
    [`.MuiDataGrid-columnHeaderTitleContainer, .MuiDataGrid-columnHeaderTitle`]: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    ['& .MuiDataGrid-cellContent']: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  [`& .${gridClasses.virtualScroller}`]: null,
  variants: [
    {
      props: ({ checkboxSelection }) => checkboxSelection,
      style: {
        [`& .${gridClasses.columnHeader}:first-of-type, .${gridClasses.cell}:first-of-type`]: {
          borderRight: 'none',
        },
      },
    },
    {
      props: ({ disableHorizontalScroll }) => disableHorizontalScroll,
      style: {
        [`& .${gridClasses.virtualScroller}`]: {
          overflowX: 'hidden',
        },
      },
    },
    {
      props: ({ disableCellSelection }) => disableCellSelection,
      style: {
        [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
          outline: 'none',
        },
      },
    },
  ],
});
